import type React from 'react';
import { Trans, useTranslator } from 'tradera/lang/translate';
import { Button } from 'tradera/components/atoms/button/button';
import { ScrollableModal } from 'tradera/components/scrollable-modal/scrollable-modal';
import BankidIcon from '@tradera/blueprint/theme/icons2/bankid.svg?jsx';
import { HeaderWithCloseButton } from 'tradera/components/scrollable-modal/header-with-close-button';

type BankIdInfoModalProps = {
    birthdate: string;
    onVerifyWithBankId: () => void;
    onCloseAction: () => void;
    text: string;
    disabled?: boolean;
    children?: React.ReactNode;
};

const BankIdInfoModal = ({
    birthdate,
    onVerifyWithBankId,
    onCloseAction,
    text,
    disabled,
    children,
}: BankIdInfoModalProps) => {
    const { t } = useTranslator();

    return (
        <ScrollableModal
            show
            maxWidth={'40rem'}
            maxHeight={'45rem'}
            onClose={onCloseAction}
            mobileBottomSheet
            header={
                onCloseAction ? (
                    <HeaderWithCloseButton onClose={onCloseAction} />
                ) : undefined
            }
            footer={
                <div>
                    <Button
                        disabled={disabled}
                        fluid
                        icon={<BankidIcon />}
                        fixedIcon
                        theme="primary"
                        onClick={onVerifyWithBankId}>
                        {t('identity_verification_verify_with_bankid')}
                    </Button>
                    <div className="text-center text-inter-medium mt-2">
                        <Trans
                            i18nKey="identity_verification_bankid_help_Trans"
                            components={{
                                csLink: <Button theme="link" target="_blank" />,
                            }}
                        />
                    </div>
                </div>
            }>
            <div className={'d-flex flex-column align-items-center'}>
                <IdentityVerificationContent text={text} />
                <div className="text-center pt-2">
                    {`${t('identity_verification_verifying')} ${birthdate}****`}
                </div>
            </div>
            {children}
        </ScrollableModal>
    );
};

const IdentityVerificationContent = ({ text }: { text: string }) => {
    const { t } = useTranslator();

    return (
        <>
            <img
                className="mb-2"
                style={{ maxHeight: '25vw' }}
                src="https://storage.googleapis.com/static.tradera.net/touchweb/static/images/bankid/verify-card.svg"
                alt=""
            />
            <h3 className="text-styled">
                {t('identity_verification_modal_header')}
            </h3>
            <p className="text-center mb-0">{text}</p>
        </>
    );
};

export default BankIdInfoModal;
